export default "/images/vendor/flag-icons/flags/1x1/gu.svg?bc2f83639f0ccad757e54c13647ab9b2";